import './about.scss'
import JohnBehrProfile from './JohnBehrProfile'

const AboutPage = () => <JohnBehrProfile />

export default AboutPage
